import services from './../../services/service'; // Service Class
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
import CreateThread from '../CreateThread.vue';
import utilities from '../../services/utility'
let service = new services();
let utility = new utilities();

export default {
    name: 'Forum',
    data () {
        return {
            user:{},
            thr_data: {},
            comments: {},
            comment: {},
            forum:{},
            user:{},
            imageForm: {},
            forum_can_edit: false,
            edit_image_set: false,
            img_url: service.imageURL,
            // siteUrl:service.siteUrl+"forum?topic=",
            siteUrl:service.siteUrl+"?topic=",
            siteImage: service.siteImage,
            loggedIn:false,
        }
    },
    // metaInfo() {
    //     return{
    //         title: this.metaPrep("title"),
    //         titleTemplate: '',
    //         meta: [
    //             { 'property': 'og:description', 'content': this.metaPrep("title"), 'vmid': 'og:description', 'og:image':this.metaPrep("image")}
    //           ],
    //     }
    // },
    components: {
        'second-header': SecondHeader,
        'main-footer': MainFooter,
        'create-thread': CreateThread
    },
    
    methods: {
        setComponent(attr1,attr2){
            if(attr1 == "forum_comment"){
                this.comment = attr2;
            }
        },
        metaPrep(attr){
            let prep = this.$route.query.topic + " Forums - Cityneeds(cityneeds.ng)"
            if(attr == "title"){
                return this.forum.forum_topic + " Forums - Cityneeds(cityneeds.ng)";
            }
            if(attr == "image"){
               // return this.forum.forum_attachment || this.siteImage;
               return this.forum.forum_attachment;
            }
        },
        copyLink() {
            // this.$refs = "ioioio";
            // document.execCommand('copy');
            // this.setTooltip('Copied!');
            // this.hideTooltip();
            this.$clipboard(this.forum.forum_url)
            var btn = $('.linky').tooltip({
                trigger: 'click',
                placement: 'bottom'
              });
            this.setTooltip(btn, 'Copied');
            this.hideTooltip(btn);
        },
        // setTooltip(message) {
        //     $('.linky').tooltip('hide')
        //       .attr('data-original-title', message)
        //       .tooltip('show');
        //   },
          
        // hideTooltip() {
        //     setTimeout(function() {
        //       $('.linky').tooltip('hide');
        //     }, 1000);
        // },
        setTooltip(btn, message) {
            btn.tooltip('hide')
              .attr('data-original-title', message)
              .tooltip('show');
          },
          
        hideTooltip(btn) {
            setTimeout(function() {
              btn.tooltip('hide');
            }, 1000);
        },
        
        setForumDsc(text){
            let p_fmttd = "";
           // var text=document.getElementById("url").value;
            var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
            var text1 = text.replace(exp, "<a href='$1'>$1</a>");
            var exp2 =/(^|[^\/])(www\.[\S]+(\b|$))/gim;

            p_fmttd =text1.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');

            return p_fmttd;
        },

        //settings
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            //set can_edit
                           // this.can_edit();
                         }, this);
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                      this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
        },

        preset2() { //must not login, provide CNUser ID
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                    }else {
                        // this.$router.push('login');
                        if(localStorage.getItem("cgt") == null){
                            this.prepareCNuserGuestID();
                        }else{
                            this.user.user_id = localStorage.getItem("cgt");
                        }
                    }
                }).catch((err) => {
                    if(localStorage.getItem("cgt") == null){
                        this.prepareCNuserGuestID();
                    }else{
                        this.user.user_id = localStorage.getItem("cgt");
                    }
                })
            }else {
                if(localStorage.getItem("cgt") == null){
                    this.prepareCNuserGuestID();
                }else{
                    this.user.user_id = localStorage.getItem("cgt");
                }
            }
            
        },

        //--//settings
        trackevent: function(event){
            if(event.isTrusted){
                localStorage.setItem("cn_prv_page","forums");//log current page
                // this.preset();
                this.preset2();
            }
           
        },
        can_edit(){
            let data = {};
            data.data_id = this.forum.forum_id;
            data.data_owner = this.user.user_id;
            data.data_type = "forums";
            service.canEditData(this, data).then((res) => {
                if (res.status == 200) { 
                   this.forum_can_edit = true;
                }else{
                    //
                }
            }) 
        },
        can_edit_comment(forum){
            if(forum == this.user.user_id){
                return true;
            }
        },

        // Get thread data
        thread() {
            let id = this.$route.params;
             let uid = id.id;
            service.getThread(this, uid).then((res) => {
                this.thr_data = res.body.data;
            })
        },

        // Add comment to thread
        addCommentXX() {
            if(this.user.user_id != undefined){
                let tid = this.$route.params.id;
                let data = this.comment;
                //data.forum_comment_forum = this.$route.params.id;
                //data.forum_comment_user = utility.getUserId();
                data.forum_comment_forum = localStorage.getItem("cn_f");
                data.forum_comment_user = this.user.user_id;
                service.addThreadComment(this, data).then((res) => {
                    if (res.status == 201) { 
                        toastr.success("Comment successfully posted", "Success!");
                        location.reload();
                    }else{
                        toastr.warning("Couldn't complete request, kindly try again", "Warning!");
                    }
                })
            }
           
        },

        // Add comment to thread
        addComment() {
            if(this.user.user_id != undefined){
                let tid = this.$route.params.id;
                let data = this.comment;
                //data.forum_comment_forum = this.$route.params.id;
                //data.forum_comment_user = utility.getUserId();
                // data.forum_comment_forum = localStorage.getItem("cn_f");
                data.forum_comment_forum = this.forum.forum_id;
                data.forum_comment_user = this.user.user_id;
                service.addThreadComment(this, data).then((res) => {
                    if (res.status == 201) { 
                        this.comment = {}; //a check
                        //add image
                        if(this.edit_image_set){
                            let forum_comment_id = res.body.data;
                            this.imageForm.append("data_id", forum_comment_id);
                            this.imageForm.append("data_type","forum_comment_attachment");
                            service.uploadDataPhoto(this, this.imageForm).then(data => {
                                if(localStorage.getItem("cityneeds_token") == null){
                                    $('#guest-poll').modal('show');
                                }
                                //location.reload(); //moved here to make sure image is uploaded before reload
                            }).catch((err) => {
                                if(err) {
                                    // log it
                                }
                            })
                        }
                        toastr.success("Comment successfully posted", "Success!");
                        // location.reload();
                    }else{
                        toastr.warning("Couldn't complete request, kindly try again", "Warning!");
                    }
                })
            }
           
        },
        
        // Getting comments
        getComments() {
            let id = this.$route.params.id;
            service.forumComments(this, id).then((res) => {
                this.comments = res.body.data;
            })
        },

         // Getting forum
        getForumXXX() {
            let forum_id = localStorage.getItem("cn_f");
            service.getThread(this, forum_id).then((res) => {
                this.forum = res.body.data;
                //localStorage.removeItem("cn_f"); //use later if neccessary
            })
        },

        getForum() {
            //let forum_id = localStorage.getItem("cn_f");
            //set user if  logged in
            if((localStorage.getItem("cityneeds_token")) != null){
                this.preset();
            }
            var data = {
                forum_url:this.$route.query.topic
                //forum_url:this.$route.params.topic for /forums/:topic //cannot prerender dynamic
            }
            service.getThread(this, data).then((res) => {
                this.forum = res.body.data;
                this.forum.forum_url = this.siteUrl+this.forum.forum_topic_url;
                this.forum.forum_url_picture = this.forum.forum_attachment || this.siteImage;
                this.can_edit();
           })
        },

        editForum(){
            let forum_url = "";
            service.editThread(this, this.forum.forum_id, this.forum).then((response) => {
                if(response.body.status = 200) {
                    toastr.success("Thread edited", 'Ok buddy'); 
                    forum_url = response.body.data;
                    //add image
                    if(this.edit_image_set){
                        this.imageForm.append("data_id",this.forum.forum_id);
                        this.imageForm.append("data_type","forum_attachment");
                        service.uploadDataPhoto(this, this.imageForm).then(data => {}).catch((err) => {
                            if(err) {
                                // log it
                            }
                        })
                    }
                }else {
                    toastr.warning("Couldn't complete action, kindly try again", 'Warning!'); 
                }
                if(forum_url != null){
                   location.replace("/forum?topic="+forum_url);
                }
            })
        },

         // edit comment to thread
        editComment(comment) {
            if(this.user.user_id != undefined){
                service.editThreadComment(this, comment.forum_comment_id, comment).then((res) => {
                    if (res.status == 200) { 
                        //add image
                        if(this.edit_image_set){
                            this.imageForm.append("data_id", comment.forum_comment_id);
                            this.imageForm.append("data_type","forum_comment_attachment");
                            service.uploadDataPhoto(this, this.imageForm).then(data => {}).catch((err) => {
                                    if(err) {
                                    // log it
                                    }
                            })
                        }
                        location.reload();
                    }else{
                        toastr.warning("Couldn't complete request, kindly try again", "Warning!");
                        location.reload();
                    }
                })
            }
           
        },

        //uploads
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]); 
                this.imageForm = formData;
                this.edit_image_set = true;
            }   
        },
        //
        setReg(){
            let set_url = 'forum?topic='+this.forum.forum_topic_url;
            localStorage.setItem("current_page",set_url);
            localStorage.setItem("cn_prv_page",set_url);
            localStorage.setItem("cn_current_page",set_url)
            location.replace('login');
        },

        checkLoggedIn(){
            // if(localStorage.getItem("cityneeds_token") != null) {
            if(localStorage.getItem("cityneeds_token")) {
                this.loggedIn = true
            }
        },


    },
   
    mounted: function() {
       // this.thread();
       this.checkLoggedIn();
        this.getForum();
        //this.getComments();
    },
    
    // created: function() {  
    //     document.title = this.forum.forum_topic + "so cityneeds"  
    //     document.head.querySelector('meta[name=description]').content = this.forum.forum_topic + 'New Description'  
    //   }
}


// WEBPACK FOOTER //
// ./src/components/Forum/script.js